import React, { useState, useEffect } from "react";
import { Image, Link as LinkIcon, X, Plus } from "lucide-react";

export default function AdminImages() {
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [data, setData] = useState([]);

  const [collection, setCollection] = useState([]);
    
  const [showCollectionFor, setShowCollectionFor] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    image: ""
  });

  useEffect(() => {
    fetchImages();
  }, []);

  
  useEffect(() => {
    if (showForm) {
      fetchCollection();
    }
  }, [showForm]);

  const fetchImages = async () => {
    const res = await fetch("/api/admin/assets/images.php");
    const images = await res.json();
    setData(images);
  };

  const fetchCollection = async () => {
    const res = await fetch("/api/admin/assets/collection.php");
    const collection = await res.json();
    setCollection(collection);
  };

  async function handleSubmit(e) {
  e.preventDefault();

  const url = "/api/admin/assets/edit_image.php"

  const form = new FormData();
  form.append("name", formData.name);

  ["image"].forEach(field => {
    if (formData[field] instanceof File) {
      form.append(field, formData[field]);
    } else if (typeof formData[field] === "string" && formData[field]) {
      form.append(field, formData[field]);
    }
  });

  if (editingId) {
    form.append("id", editingId);
  }

  try {
    const res = await fetch(url, {
      method: "POST",
      body: form
    });

    if (!res.ok) throw new Error("Erreur sauvegarde");

    fetchImages();
    resetForm();
  } catch (err) {
    console.error(err);
    alert("Erreur upload");
  }
}

  function resetForm() {
    setShowForm(false);
    setEditingId(null);
    setFormData({
                                name: "",
                                image: ""
    });
  }

  function editImage(_image) {
    setFormData({
      name: _image?.name ?? "",
      image: _image?.image ?? "",
    });

    setEditingId(_image.id);
    setShowForm(true);
  }

  return (
      <section>
      <div>
                <div className="container-xl">
                  <div className="bg-white rounded shadow p-4">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h1 className="cat-title h3 fw-bold text-dark d-flex align-items-center gap-2">
                          <Image className="text-primary" />
                          Images
                        </h1>
                        <p className="text-secondary mb-0">
                          Modifier des images
                        </p>
                      </div>
                    </div>
                  {showForm && (
                    <div className="bg-primary bg-opacity-10 p-4 rounded mt-4 w-100">
                      <h3 className="fw-semibold mb-3">
                        Modifier l'image
                      </h3>
      
                      <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                              <div className="col-12">
                                <label className="form-label fw-medium" htmlFor='title'>Nom</label>
                                <p>{formData.name}</p>
                              </div>
                              <div className="col-12">
                                <label className="form-label fw-medium" htmlFor='img'>Image</label>
                                <input
                                  className="form-control"
                                  type="file"
                                  accept="image/*"
                                  name="image"
                                  onChange={(e)=> setFormData({...formData, image: e.target.files[0]})}
                                />
                                <button
                                  type="button"
                                  className="btn
                                   btn-sm col-3 btn-outline-primary mt-2"
                                  onClick={() => setShowCollectionFor("image")}
                                >
                                  Collection
                                </button>
                                <div>
                                {/* Image existante */}
                                {typeof formData.image === "string" && formData.image && (
                                  <img
                                    src={formData.image}
                                    alt="preview"
                                    style={{ width: "200px", marginTop: "10px" }}
                                  />
                                )}

                                {/* Nouvelle image */}
                                {formData.image instanceof File && (
                                  <img
                                    src={URL.createObjectURL(formData.image)}
                                    alt="preview"
                                    style={{ width: "200px", marginTop: "10px" }}
                                  />
                                )}
                                </div>
                            </div>
      
                            <div className="d-flex gap-2 mt-4">
                              <button type="submit" className="btn btn-primary">
                                {editingId ? "Modifier" : "Enregistrer"}
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setShowForm(false);
                                  setEditingId(null);
                                  setFormData({
                                    name: "",
                                    image: ""
                                  });
                                  setShowCollectionFor(null);
                                }}
                                className="btn btn-secondary"
                              >
                                Annuler
                              </button>
                            </div>
                            </div>
                          </form>
                        </div>
                      )}
                      {showCollectionFor && (
                        <div className="mt-4 p-3 border rounded bg-light">
                          <h5>Sélectionner une image</h5>

                          <div className="row">
                            {collection.map((img) => (
                              <div className="col-3 mb-3" key={img.id}>
                                <img
                                  src={img.image}
                                  alt=""
                                  style={{ width: "100%", cursor: "pointer" }}
                                  onClick={() => {
                                    setFormData({
                                      ...formData,
                                      [showCollectionFor]: img.image
                                    });
                                    setShowCollectionFor(null);
                                  }}
                                />
                              </div>
                            ))}
                          </div>

                          <button
                            type="button"
                            className="btn btn-secondary btn-sm mt-2"
                            onClick={() => setShowCollectionFor(null)}
                          >
                            Fermer
                          </button>
                        </div>
                      )}
                      <div className="row g-3 pt-4">
                        {data.map((image, i) => {
      
                          return (
                            <div className="col-md-4 mb-3" key={image.id}>
                              <div className="card border-dark bg-white rounded shadow p-3 h-100">
                                <div className="border-bottom pb-2 mb-2">
                                  <h2 className="h4 fw-bold">{image.name}</h2>
                                  <img
                                    src={image.image}
                                    alt="preview"
                                    style={{ width: "100%", marginTop: "10px" }}
                                  />
                                </div>
                                          <div className="d-flex gap-1">
                                            <button
                                              onClick={() => editImage(image)}
                                              className="btn btn-sm btn-outline-dark"
                                              title="Modifier"
                                            >
                                              Modifier
                                            </button>
                                          </div>
                                  </div>
                            </div>
                          );
                        })}
                      </div>
                  </div>
                </div>
              </div>
    </section>
  );
}